import React, { useEffect, useRef, useState } from 'react';
import './../../../Styles/Cart/AddOns.css';
import addImg from './../../../assets/svg/Group.svg';
import foodPlaceHolder from '../../../assets/food-img-placeholder.jpg';
import { useCart } from '../../../CartProvider';
import { toast } from 'react-toastify';
import axiosUserInstance from '../../../axiosUserInstance';
import Loader from '../../../Components/Loader/Loader';
import axiosVendorInstance from '../../../axiosVendorInstance';
import FoodMenuDetailsModal from '../Search/FoodMenuDetailsModal';
import { IoPlayOutline } from 'react-icons/io5';

function AddOns({
    cartData,
    fetchDataFromCart = () => {},
    onVendorDetails = () => {},
}) {
    const { fetchCartCount } = useCart();
    const [isLoading, setIsLoading] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedFood, setSelectedFood] = useState(null);
    const [open, setOpen] = useState(false);
    const vendorId = cartData?.[0]?.Vendor_Id;
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);

    const handlePlay = (e, index) => {
        e.stopPropagation();

        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });

        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFood(null);
    };

    const fetchMenuItems = async () => {
        setIsLoading(true);

        let allMenuItems = [];
        let pageNo = 1;
        const pageSize = 100;
        let hasMoreData = true;

        try {
            while (hasMoreData) {
                const response = await axiosVendorInstance.get(
                    `/vendors/menuitems/${vendorId}`,
                    {
                        params: {
                            page_no: pageNo,
                            page_size: pageSize,
                        },
                        skipAuth: true,
                    }
                );

                const items = response?.data?.menuItems || [];

                const menuItems = items
                    ?.filter((item) => item?.Status !== 'deactive')
                    ?.map((item) => ({
                        menuItemId: item?.ID,
                        vendorDesc: item?.Vendor_Info?.Vendor_Description || 'N/A',
                        vendorRating: item?.vendor_menu?.Rating || 'N/A',
                        vendorReview: item?.vendor_menu?.Review || 'N/A',
                        foodImage: item?.Avatar_key,
                        vegetarian: item?.Vegetarian,
                        menuItemName: item?.Item_name,
                        menuItemDescription: item?.Description,
                        menuItemPrice: item?.Price,
                        menuName: item?.vendor_menu?.Menu_name,
                        menuIngridents: item?.Ingridents,
                        vendor_address: item?.vendor_menu?.vendor?.address,
                        vendor_city: item?.vendor_menu?.vendor?.city,
                        vendor_state: item?.vendor_menu?.vendor?.state,
                        vendor_postalcode: item?.vendor_menu?.vendor?.pincode,
                        vendor_country: item?.vendor_menu?.vendor?.country,
                    }));

                allMenuItems = [...allMenuItems, ...menuItems];

                if (items.length < pageSize) {
                    hasMoreData = false;
                } else {
                    pageNo += 1;
                }
            }
            setFilteredItems(allMenuItems);

            const firstItem = allMenuItems[0];
            if (firstItem) {
                onVendorDetails({
                    vendor_address: firstItem.vendor_address,
                    vendor_city: firstItem.vendor_city,
                    vendor_state: firstItem.vendor_state,
                    vendor_postalcode: firstItem.vendor_postalcode,
                    vendor_country: firstItem.vendor_country,
                });
            }
        } catch (error) {
            console.error('Error fetching restaurant details:', error);
            setFilteredItems([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMenuItems();
    }, [vendorId]);

    const addOnItems = filteredItems.filter(
        (item) =>
            !cartData.some((cartItem) => cartItem?.Item_ID === item?.menuItemId)
    );

    const addToCart = async (e, itemID, restaurantID) => {
        e.stopPropagation();
        localStorage.setItem('itemID', itemID);

        try {
            const itemIdToSend = {
                Item_id: itemID,
                Quantity: 1,
            };
            setIsLoading(true);
            await axiosUserInstance.post(
                `/cartdetails/customer/vendor/${restaurantID}/item/${itemID}`,
                itemIdToSend
            );
            setIsLoading(false);
            await fetchDataFromCart();
            await fetchCartCount();
        } catch (error) {
            setIsLoading(false);
            toast.error('Failed to add item');
        }
    };

    const fetchItemDetails = async (itemId) => {
        try {
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`,
                { skipAuth: true }
            );
            setSelectedFood(response?.data?.menuItem);
            setOpen(true);
        } catch (error) {
            console.error('Error fetching offer details:', error);
        }
    };

    return (
        <>
            {isLoading && (
                <div>
                    <Loader />
                </div>
            )}
            {addOnItems?.length > 0 && (
                <>
                    <h1 className='add-ons-title add-ons-title-padding'>Add Items</h1>
                    <div className='add-ons-line add-ons-line-padding'></div>
                    <div className='add-ons-container'>
                        {addOnItems?.map((item, index) => {
                            return (
                                <div
                                    className='items-container'
                                    key={item?.menuItemId}
                                    onClick={() => fetchItemDetails(item?.menuItemId)}
                                >
                                    <div className='add-item-media-wrapper'>
                                        {item?.foodImage?.match(/\.(mp4|webm|ogg)$/i) ? (
                                            <div className='add-item-video-container1'>
                                                <video
                                                    src={item?.foodImage}
                                                    muted
                                                    playsInline
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    webkit-playsinline='true'
                                                    preload='metadata'
                                                    className='add-item-food-video'
                                                    ref={(el) => (videoRefs.current[index] = el)}
                                                    onClick={() => {
                                                        const video = videoRefs.current[index];
                                                        if (video && !video.paused) {
                                                            video.pause();
                                                            setPlayingIndex(null);
                                                        }
                                                    }}
                                                    onEnded={() => setPlayingIndex(null)}
                                                    onError={(e) => {
                                                        e.target.poster = foodPlaceHolder;
                                                    }}
                                                />
                                                {playingIndex !== index && (
                                                    <button
                                                        onClick={(e) => handlePlay(e, index)}
                                                        className='play-btn'
                                                    >
                                                        <IoPlayOutline color='white' fontSize={34} />
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <img
                                                className='add-item-Food-image'
                                                src={item?.foodImage || foodPlaceHolder}
                                                alt='Food img'
                                                onError={(e) => {
                                                    e.target.src = foodPlaceHolder;
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className='title-price-rating-container'>
                                        <div>
                                            <h3 className='item-title'>
                                                {item?.menuItemName && item?.menuItemName.length > 25
                                                    ? item?.menuItemName.slice(0, 17) + '...'
                                                    : item?.menuItemName}
                                            </h3>
                                        </div>
                                        <div className='add-item-img'>
                                            <img
                                                className='plus-img'
                                                src={addImg}
                                                alt='plus-img'
                                                onClick={(e) =>
                                                    addToCart(e, item?.menuItemId, vendorId)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}
            {selectedFood && (
                <FoodMenuDetailsModal
                    open={open}
                    handleClose={handleClose}
                    food={selectedFood}
                    orderBtn={false}
                />
            )}
        </>
    );
}

export default AddOns;
